const TOGGLE_BUTTON_HOOK = '[js-hook-image-modal-toggle-button]';

const FULLSCREEN_CLASS = 'image-modal--active';

class ImageModal {
  constructor(element) {
    this.element = element;
    this.toggleButtons = [...this.element.querySelectorAll(TOGGLE_BUTTON_HOOK)];

    this.bindEvents();
  }

  bindEvents() {
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', () => this.toggleFullScreen());
    })
  }

  toggleFullScreen() {
    this.element.classList.toggle(FULLSCREEN_CLASS);
  }
}

export default ImageModal;
